import styled from 'styled-components'

export const StyledFacebookLayoutGeneral__ActionBtn = styled.div`
  width: 44px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  cursor: pointer;

  &[data-active='true'] svg {
    color: #e5101d;
  }

  &[data-active='true'] svg path {
    stroke: #e5101d;
  }
`
